import { useEffect, useRef, useState } from 'react'
import {
  ViewItem,
  ViewObserverWrapper,
  ViewSpinner
} from './ViewObserver.styles'
import { ViewObserverProps } from './ViewObserver.types'

const ViewObserver = ({
  showLoader = true,
  loading = false,
  offset = 0,
  data,
  entryActions,
  exitActions,
  ...props
}: ViewObserverProps) => {
  const observerRef = useRef<Element>(null)
  const [visible, setVisible] = useState(false)
  const [seen, setSeen] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries?.find(({ isIntersecting }) => isIntersecting)
      const intersecting = entry?.isIntersecting
      setVisible(!!entry && !!intersecting)
      if (intersecting) {
        setSeen(true)
      }
    })

    if (observerRef.current) {
      observer.observe(observerRef.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    if (!loading && seen) {
      if (visible) {
        entryActions?.({ data })
      } else {
        exitActions?.({ data })
      }
    }
    // eslint-disable-next-line
  }, [visible, seen])

  return (
    <ViewObserverWrapper className="Observer" {...props}>
      <ViewItem className="ObserverTarget" ref={observerRef} offset={offset} />
      <ViewSpinner className="ObserverLoader" show={showLoader && loading} />
    </ViewObserverWrapper>
  )
}

export default ViewObserver
